import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PayInput from './PayInput';
import './PayPwd.scss';

class PayPwd extends Component {
  pwdSureBack = (value, bool) => {
    if (bool) {
      this.props.sureInput(value);
    }
  }

  render () {
    return (
      <div className='mask'>
        <div className='payPwd'>
          <div className='payPwd-title'><i className='iconfont icon-close' onClick={this.props.closePayPwd}></i>请输入支付密码</div>
          <div className='payPwd-input'>
            <PayInput pwdError={this.props.pwdError} pwdSureBack={this.pwdSureBack} height='0.72rem' marginRight='0.16rem'></PayInput>
          </div>
          <Link to='/password'>
            <div className='payPwd-forget'>忘记密码？</div>
          </Link>
        </div>
      </div>
    )
  }
}

PayPwd.propTypes = {
  closePayPwd: PropTypes.func.isRequired,
  sureInput: PropTypes.func.isRequired,
  pwdError: PropTypes.bool
}

export default PayPwd;